import { render, staticRenderFns } from "./RelativityViz.vue?vue&type=template&id=4d1942ab&scoped=true"
import script from "./RelativityViz.vue?vue&type=script&lang=js"
export * from "./RelativityViz.vue?vue&type=script&lang=js"
import style0 from "./RelativityViz.vue?vue&type=style&index=0&id=4d1942ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1942ab",
  null
  
)

export default component.exports